module.exports = __webpack_public_path__ + "static/media/ic_arrow_down.470e1a88.svg";